import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileDto } from 'src/app/components/profile/panel-start/dto/profile';
import { ProfileService } from 'src/app/components/profile/services/profile.service';

@Component({
  selector: 'app-community',
  templateUrl: './community.component.html',
  styleUrl: './community.component.css',
})
export class CommunityComponent {
  profile!: ProfileDto;
  isBootcamp: boolean = false;
  isForo: boolean = false;

  constructor(
    private router: Router,
    private profileService: ProfileService,
  ) {
    // do nothing
  }
  async getInfo() {
    const result = await this.profileService.getInfo();
    this.profile = result;
    // console.log(result);
  }
  verMasBootcamp() {
    this.isBootcamp = true;
  }
  verMasForo() {
    this.isForo = true;
  }
  cerrar() {
    this.isBootcamp = false;
    this.isForo = false;
  }
}
